<template>
  <div class="notice-wrapper" :class="{'open': show}">
    <div style="padding: 10px 0 20px 0;">{{ $t('【问题件处理】您当前有待处理的问题件') }}</div>
    <div style=" text-align: right;">
      <el-button type="plain" size="mini" @click="close">{{ $t('关闭') }}</el-button>
      <el-button type="primary" size="mini" @click="toPage">{{ $t('立即查看') }}</el-button>
    </div>
  </div>
</template>

<script>
import { fetchProblemNoticeStatus } from '@/api/module/problemPiece.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ProblemPieceNotice',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(val) {
      console.log('show-->', val)
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    toPage() {
      this.handleStatus()
      this.$emit('update:show', false)
      this.$router.push('/problemHandling')
    },
    close() {
      this.handleStatus()
      this.$emit('update:show', false)
    },
    async handleStatus() {
      if (this.user.customerCode) {
        await fetchProblemNoticeStatus({
          customerCode: this.user.customerCode
        })
        await this.$store.dispatch('problemInform', 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-wrapper {
  position: fixed;
  right: -350px;
  width: 330px;
  top: 60px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  background-color: #FFFFFF;
  overflow: hidden;
  z-index: 999;
  padding: 14px 26px 14px 13px;
  border-radius: 8px;
  box-sizing: border-box;

  &.open {
    right: 20px;
  }
}
</style>
